import { chain, filter } from "lodash"
import { sanitizePositionSet } from "../helpers"

const QUERY = `query ($modelId: String!, $contentSetId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $date: Date!) {
  model (id: $modelId) {
    simulation (positionSet: $positionSet, base: $base, from: $date, to: $date) {
      exposure (contentSetId: $contentSetId) {
        factors {
          id
          name
          category
          net
        }
      }
    }
  }
}`

export function createContentSetExposureSingleDateQuery(modelId, contentSetId, positionSet, base, date, options = {}) {
  return {
    key: ["content-set", contentSetId, "exposure", "singleDate", modelId, positionSet, base, date],
    query: QUERY,
    variables: {
      contentSetId,
      modelId,
      positionSet: sanitizePositionSet(positionSet),
      base,
      date,
    },
    select: (data) => {
      const values = chain(data)
        .get("data.model.simulation.exposure.0.factors")
        .thru(factors => {
          if (options.category) {
            return filter(factors, f => f.category === options.category)
          }
          return factors
        })
        .filter(({ net }) => net !== null)
        .keyBy("id")
        .mapValues(({ name, net }) => ({
          label: name,
          value: net,
        }))
        .value()

      return {
        values,
      }
    },
  }
}
